import React from "react"

import { ClickableCard } from "../../../common/starterpacks"

import { IRCAFinding } from "../.."

export interface Props {
    finding: IRCAFinding
}

export const Actions = ({
    finding: { id, isMarkedAsRootCause, actions },
}: Props): JSX.Element => {
    if (!isMarkedAsRootCause || !actions || actions.length === 0) {
        return <></>
    }

    return (
        <div
            className="tw-flex tw-flex-col tw-pb-1 tw-px-2"
            data-ft-component="actions"
            data-ft-id={id}
            data-ft-count={actions.length}
        >
            {actions.map((action) => (
                <ClickableCard element="action" key={action.id} {...action} />
            ))}
        </div>
    )
}

export default Actions
